module.exports = __webpack_public_path__ + "images/63193205a2216bcfdddd9738435e2287.svg";